<template>
	<div class="book-detail">
		<!-- 图书信息 -->
		<div class="book-detail-info">
			<div class="cover">
				<img :src="bookDetails.coverUrl" :key="bookDetails.bookId" @error="handleErrorImage($event)"  referrerpolicy="no-referrer"/>
			</div>
			<div class="right">
				<h1>{{ bookDetails.title }}</h1>
				<p>
					<span class="label">作者:</span>
					<span class="value">{{ bookDetails.author }}</span>
				</p>
				<p>
					<span class="label">出版社:</span>
					<span class="value">{{ bookDetails.publisher }}</span>
				</p>
				<p class="price">￥{{ bookDetails.price }}</p>
			</div>
		</div>
		<!-- 馆藏和供应商 -->
		<van-cell-group class="collections-booksellers">
      <!--馆藏-->
      <van-cell center :title="institution" :url="isLibLink" v-if="isLibLink" class="location">
        <template #right-icon>
          <van-button type="primary" icon-prefix="iconfont icon" icon="dangqianzaijie">
            馆藏链接
          </van-button>
        </template>
      </van-cell>
      <!--供应商-->
			<van-cell center title="供应商" :value="vendorName" class="vendor"/>
		</van-cell-group>
		<!-- 信息 -->
		<van-cell-group>
			<van-cell center title="ISBN" :value="bookDetails.isbn"/>
			<van-cell center title="出版时间" :value="bookDetails.publicationDate"/>
			<van-cell center title="库存" :value="bookDetails.inventory"/>
		</van-cell-group>
		<!-- 内容简介+章节 -->
		<div class="book-detail-content">
			<!-- 内容简介 -->
			<div v-if="bookDetails.content">
				<h3>内容简介</h3>
				<div class="content" v-html="bookDetails.content"></div>
			</div>
			<!-- 章节 -->
			<div v-if="catalogs && catalogs.length > 0">
				<h3>章节</h3>
				<div class="chapter">
					<p v-for="(item, index) in catalogs" :key="index">
						<template v-if="index < 5 || moreCatalog">
							{{ item }}
						</template>
					</p>
				</div>
				<div class="more" @click="moreCatalog = !moreCatalog;" v-if="catalogs && catalogs.length > 5">
					{{ moreCatalog ? "收起" : "更多" }}
					<van-icon :name="moreCatalog ? 'arrow-up' : 'arrow-down'"></van-icon>
				</div>
			</div>
		</div>
	</div>
	<van-action-bar>
    <div class="left">
      <span class="van-submit-bar__price">
        ¥<span class="van-submit-bar__price-integer">{{ bookDetails.price }}</span>
      </span>
    </div>
		<van-action-bar-button type="warning" text="加入购物车" @click="addToCart"/>
		<van-action-bar-button type="danger" text="立即购买" @click="onConfirm"/>
	</van-action-bar>
</template>

<script>
import {defineComponent, computed, watch, ref} from 'vue';
import {getLibLink, isNotEmpty, loginInterceptor, randomBookCover, setCovers} from '@/utils/util';
import store from '@/store';
import {getBookDetail} from '@/api/books';
import {addCart, cartCheck, confirm, checkDuplicate} from '@/api/carts';
import {getVendor} from '@/api/vendor';
import {getCartNum, getConsignee} from '@/api/users';
import {Toast, Dialog} from 'vant';
import {useRouter,useRoute} from "vue-router";

export default defineComponent({
	name: 'BookDetail',
	props: {
		bookId: {
			type: String,
			default: ''
		}
	},
	setup(props) {
		const router = useRouter();
		const route = useRoute();
		const bookId = computed(() => {
			return props.bookId;
		});
		const uid = computed(() => {
			return store.state.reader.user.uid;
		});
		const institution = computed(() => {
			return store.state.reader.institution;
		});
		const bookDetails = ref({});
		const catalogs = ref([]); // 章节
		const moreCatalog = ref(false); // 章节
		const vendorName = ref(''); // 供应商
		const isLibLink = ref(false); // 是否有馆藏链接
		const onBookDetail = () => {
			getBookDetail(bookId.value)
					.then(data => {
						if (data) {
							bookDetails.value = data;
							if (bookDetails.value.vendorId) {
								onVendor(bookDetails.value.vendorId);
							}
							if (!isNotEmpty(bookDetails.value.coverUrl) && isNotEmpty(bookDetails.value.isbn)) {
								setCovers([bookDetails.value.isbn],[bookDetails.value])
							}
							if (bookDetails.value.chapter) {
								catalogs.value = bookDetails.value.chapter.split('\n');
							} else {
								catalogs.value = [];
							}
							if (uid.value && data.isbn && data.title) {
								onCheckDuplicate(data.isbn, data.title);
							}
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		// 供应商
		const onVendor = (vendorId) => {
			getVendor(vendorId)
					.then(data => {
						if (data) {
							vendorName.value = data.vendorName;
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		const addToCart = () => {
			if (loginInterceptor(route.path)) {
				// 查询此书是否已加入购物车
				onCartCheck('0');
			}
		};
		// 获取购物车数量
		const onCartNum = () => {
			getCartNum()
					.then(data => {
						store.commit('setCartNum', data);
					})
					.catch((error) => {
						console.error(error);
					});
		};
		const onCartCheck = (num) => {
			cartCheck(bookDetails.value.bookNo, bookDetails.value.vendorId)
					.then(data => {
						if (data === null || data.cartStatus === 1) {
							// 加入购物车
							switch (num) {
								case '0':
									// 加入购物车
									onAddToCart();
									break;
								case '1':
									// 立即购买
									confirmOrder();
									break;
							}
						} else if (data) {
							switch (data.cartStatus) {
								case 0:
									if (num === '0') {
										Toast({message: '此书已在购物车'});
									} else if (num === '1') {
										Toast({message: '此书已在购物车,请在购物车购买'});
									}
									break;
								case 2:
									Toast({message: '此书已下过单无法再次下单'});
									break;
								case 3:
									Toast({message: '此书已在待确认订单中'});
									break;
							}
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		// 加入购物车
		const onAddToCart = () => {
			let param = new URLSearchParams();
			param.append('bookNo', bookDetails.value.bookNo);
			param.append('vendorId', bookDetails.value.vendorId);
			addCart(param)
					.then(data => {
						if (data?.data !== null && data?.code === 0) {
							Toast({message: '加入成功'});
							onCartNum();
						} else {
							Toast({message: '加入失败:' + data?.msg});
						}
					})
					.catch((error) => {
						Toast({message: '加入失败:' + error});
						console.error(error);
					});
		};
		// 立即购买
		const onConfirm = () => {
			if (loginInterceptor(route.path)) {
				// 判断有无库存
				if (bookDetails.value.inventory > 0) {
					// 是否有收货地址
					onConsignee();
				} else {
					Toast({message: '此书暂无库存，无法购买'});
				}
			}
		};
		const onConsignee = () => {
			getConsignee()
					.then(data => {
						if (isNotEmpty(data)) {
							// 查询此书是否已加入购物车
							onCartCheck('1');
						} else {
							Dialog.confirm({
								title: '用户暂无收货地址,去设置',
							})
									.then(() => {
										router.push({path: '/receivingAddressEdit'});
									})
									.catch(() => {
									});
						}
					})
					.catch((error) => {
						console.error(error);
            Dialog.confirm({
              title: '用户暂无收货地址,去设置',
            })
                .then(() => {
                  router.push({path: '/receivingAddressEdit'});
                })
                .catch(() => {
                });
					});
		};
		const confirmOrder = () => {
			// 加入购物车
			let param = new URLSearchParams();
			param.append('bookNo', bookDetails.value.bookNo);
			param.append('vendorId', bookDetails.value.vendorId);
			addCart(param)
					.then(data => {
						if (data?.data !== null && data?.code == 0) {
							// 确认提交
							toConfirm(data?.data);
						} else {
							Toast({message: '添加到购物车失败:' + data?.msg});
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		// 确认提交
		const toConfirm = (data) => {
			let param = new URLSearchParams();
			param.append('cartIds[]', data);
			confirm(param)
					.then(data => {
						if (data === null) {
							router.push({path: '/toBeConfirmed'});
						} else {
							Toast({message: '购买失败'});
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		const onCheckDuplicate = (isbn, title) => {
			checkDuplicate(isbn, title)
					.then(data => {
						if (data && data.isDuplicate) {
							let link = '';
							if (data['pda.check.duplicate.title']) {
								link = `isbn=${bookDetails.value.isbn}&title=${bookDetails.value.title}`;
							} else {
								link = `isbn=${bookDetails.value.isbn}`;
							}
							isLibLink.value = getLibLink(link);
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		function handleErrorImage(event){
			event.srcElement.src = randomBookCover();
		}
		watch(
				bookId, () => {
					if (isNotEmpty(bookId.value)) {
						onBookDetail();
					}
				},
				{immediate: true}
		);
		return {
			bookDetails,
			catalogs,
			moreCatalog,
			vendorName,
			addToCart,
			onConfirm,
			institution,
			isLibLink,
			handleErrorImage
		}
	}
});
</script>

<style scoped lang="less">
@import "../assets/css/book-detail.less";
</style>
